module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/banner_hiramatsu@2x-b81bc8fbe6834e9881492d08cae2d430.webp";